import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../../../components/button/Button';
import ModalType from '../../../models/ModalType';

import { InsurancesCarousel } from '../../../components/insurancesCarousel/InsurancesCarousel';
import { useModal } from '../../../context/ModalContext';
import useEnrollmentUrl from '../../../hooks/useEnrollmentUrl';

import './heroV2Section.scss';

export default function HeroV2Section(props) {
  const {
    title,
    subtitle,
    button,
    backgroundUrl,
  } = props;

  const { enrollmentUrl } = useEnrollmentUrl();
  const { openModal } = useModal();

  return (
    <section className="hero-v2">
      <div className="content">
        <div className="title-container">
          <h2>{parse(title)}</h2>
          <h6>{parse(subtitle)}</h6>
          <Button
            text={button}
            displayArrow
            dataAttr="CTA_clicked_hero"
            className="blue"
            link={enrollmentUrl}
          />
        </div>
        <div className="image-container">
          <img
            // eslint-disable-next-line react/no-unknown-property
            fetchPriority="high"
            src={backgroundUrl}
            alt="home-background"
          />
        </div>
      </div>

      <div className="insurances-container">
        <InsurancesCarousel />
        <Button
          text="Am I covered?"
          displayArrow
          dataAttr="CTA_clicked_insurance"
          onClick={() => {
            if (window.posthog) window.posthog.capture('eligibility_check_clicked');
            openModal(ModalType.CHECK_ELIGIBILITY);
          }}
        />
      </div>
    </section>
  );
}

HeroV2Section.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  backgroundUrl: PropTypes.string.isRequired,
};
